import { Component, OnInit, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import {
  MessagesActionTypes,
  SendNewMessage,
  GetInbox,
  CheckViewAccessGorDocStart,
  ClearViewAccess,
  AddMessageTag,
  GetSearchedMail,
} from '../_store/messages.actions';
import { MatAutocomplete } from "@angular/material";
import { Actions, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { API } from 'src/app/services/Api.service';
import { NotificationsService } from 'angular2-notifications';
import { Store } from "@ngrx/store";
import { AppState } from "../../../../app.reducer";
import * as moment from 'moment-mini-ts'
import { AllDocumentsDialogComponent } from 'src/app/dialogs/all-documents-dialog/all-documents-dialog.component';
import { UploadDocumentDialog } from 'src/app/dialogs/upload-document/upload-document-dialog.component';
import { CommonService } from 'src/app/services/tasks.services';
import { LoaderShow, LoaderHide } from 'src/app/features/loader/store/loader.actions';
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { TagMessagesDialogComponent } from '../../../../dialogs/tag-messages-dialog/tag-messages-dialog.component';
import { DocAccessPermissionComponent } from 'src/app/features/common-components/doc-access-permission/doc-access-permission.component';

@Component({
  selector: 'compose-message',
  templateUrl: './compose-message.component.html',
  styleUrls: ['./compose-message.component.scss']
})
export class ComposeMessageComponent implements OnInit, OnDestroy {

  form: FormGroup;
  noRecipient: boolean = false;
  toRecipient: Array<any> = [];
  ccRecipient: Array<any> = [];
  defaultSelection: Array<string> = [];
  messageType: string = 'new';
  currentUser;
  inReplyTo: string;
  references: Array<string> = [];
  mail: any = {
    subject: '',
    content: '',
  }
  readOnly: boolean = true;
  docsList: Array<any> = [];
  defaultSelectionObject: Array<any> = [];
  ViewAccessClicked: boolean = false;
  loggedInUserId: string;
  stopper$: Subject<any> = new Subject()
  sendButtonClicked: boolean = false;
  payload: any;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectedTags: any = [];
  selectedTagWithId: any = [];
  selectedTagIds: any = [];
  tagsList: any = [];
  tag: string = ''
  addTag: boolean = false
  invalidTag: boolean = false;
  removable = true;
  newSelectedTagIds: Array<any> = []
  specialCharregex = new RegExp(/[A-Za-z0-9]*$/);
  multiSpaceRegex = new RegExp(/\w*[ ]{2,}\w*$/);
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;
  mailSubject: FormControl = new FormControl('');
  allowedCharacters;
  maxLengthExceeded: boolean = false;
  permissionsGiven = false;
  recipentList: any = { to: [], from: [] }
  replyFlag: boolean = false
  replyOne: any = { flag: false, userId: '' };

  constructor(
    public dialogRef: MatDialogRef<ComposeMessageComponent>,
    public action$: Actions,
    private api: API,
    private fb: FormBuilder,
    private notificationService: NotificationsService,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public commonService: CommonService,
  ) {
    this.dialogRef.disableClose = true;
    this.store.select(state => state.auth.user).subscribe((userDetails: any) => this.currentUser = userDetails);
    /* this.form = this.fb.group({
      subject: [''],
    }); */
    /* read configuration for subject length */
    this.store.select(state => state.configurations.configurations)
      .pipe(takeUntil(this.stopper$)).subscribe((resp: any) => {
        if ((resp || {}).messageSubjectLength) {
          this.allowedCharacters = resp.messageSubjectLength.value;
        }
      });

    if (data) {
      this.messageType = data.type || 'new';
      const emailMessages = data.info.messages || [];
      const msgIndex = data.index;
      const currentMessage = emailMessages[msgIndex] || {};
      if (msgIndex !== -1) {
        let clickedMessage = data.info.messages[msgIndex]
        this.docsList.push(...clickedMessage.attachments);
      }

      // this.docsList =this.docsList.flat()
      if (['reply', 'reply-all'].includes(this.messageType)) {
        this.inReplyTo = data.info.messages[0].threadId;
        this.references = [data.info.messages[0].threadId];
        /* if(typeof msgIndex !== 'undefined') {
          this.references = emailMessages.map((message: any, index: number) => {
            if(index <= msgIndex) return message._id;
          });
        } */
      }
      if (['forward'].includes(this.messageType)) {
        this.references = data.info.messages[0].threadId;
        // this.references = [data.info.threadId]
      }
      this.replyFlag = false
      switch (this.messageType) {
        case 'reply':
        case 'reply-all':
          this.replyFlag = true
          // this.subject = "Re: ";
          this.mail.subject = (currentMessage.subject.trim().slice(0, 3) === "Re:") ? currentMessage.subject : `Re: ${currentMessage.subject}`;
          /* this.form.patchValue({
            subject: (currentMessage.subject.trim().slice(0, 3) === "Re:") ? currentMessage.subject : `Re: ${currentMessage.subject}`
          }); */
          this.defaultSelection = [];

          this.recipentList.to = data.info.messages[data.index].to;
          this.recipentList.from.push(data.info.messages[data.index].from);

          const recipentsNames = this.recipentList.to.map(recipent => {
            return recipent.name ?
              recipent.name :
              (recipent.firstName || '') + ' ' + (recipent.middleName || ' ') + ' ' + (recipent.lastName);
          }).join(', ');
          if (this.messageType === 'reply') {
            this.replyOne.flag = true
            this.replyOne.userId = data.info.messages[data.index].from._id

            let messageId = data.info.messages[data.index].from._id;
            if (messageId === this.currentUser.details._id) {
              this.defaultSelection.push(...data.info.messages[data.index].to.map(({ _id }) => _id));
              this.defaultSelection = this.defaultSelection.filter(id => id !== messageId);
            } else {
              this.defaultSelection.push(data.info.messages[data.index].from._id);
              let index = this.defaultSelection.findIndex((id) => id === messageId);
              if (index === -1) {
                this.defaultSelection.push(messageId);
              }
            }
          } else if (this.messageType === 'reply-all') {
            this.replyOne.flag = false
            this.replyOne.userId = ''

            let messageId = data.info.messages[data.index].from._id;
            if (messageId == this.currentUser.details._id) {
              this.defaultSelection = data.info.messages[data.index].to.map(({ _id }) => _id);
              this.defaultSelection = this.defaultSelection.filter(id => id !== this.currentUser.details._id);
            } else {
              this.defaultSelection = data.info.messages[data.index].to.map(({ _id }) => _id).filter(id => id != this.currentUser.details._id);
              this.defaultSelection.push(data.info.messages[data.index].from._id)
              this.defaultSelection.push(messageId);

              this.recipentList.to.push(data.info.messages[data.index].from)
              this.recipentList.to.splice(this.recipentList.to.findIndex(recipient => recipient._id == this.currentUser.details._id), 1)
            }
            this.defaultSelection = this.defaultSelection.filter((id, index) => this.defaultSelection.indexOf(id) === index)
          }
          this.mail.content = `\n
                                On ${moment(
            currentMessage.createdAt).utcOffset("+05:30").format('MMM DD, YYYY hh:mm A')} ${currentMessage.fromDisplayName} wrote to
            ${recipentsNames} : \n\n  ${currentMessage.content} `;
          this.mail.content = this.mail.content;
          break;
        case 'forward':
          const recipentsNamesFwd = (currentMessage.to || []).map(recipent => {
            return (recipent.firstName || '') + ' ' + (recipent.middleName || ' ') + ' ' + (recipent.lastName);
          }).join(', ');
          this.mail.subject = (currentMessage.subject.trim().slice(0, 4) === "Fwd:") ? currentMessage.subject : `Fwd: ${currentMessage.subject}`;
          /* this.form.patchValue({
            subject: (currentMessage.subject.trim().slice(0, 4) === "Fwd:") ? currentMessage.subject : `Fwd: ${currentMessage.subject}`
          }); */
          this.mail.content = `\n
          On ${moment(
            currentMessage.createdAt).utcOffset("+05:30").format('MMM DD, YYYY hh:mm A')} ${currentMessage.fromDisplayName} wrote to 
            ${recipentsNamesFwd} : \n\n
            ${currentMessage.content}`;
          this.mail.content = this.mail.content;
          break;
        default:
          this.readOnly = false;
          break;
      }
    }
    if (data.index !== -1) {
      this.selectedTagWithId = data.info.messages[data.index].tags
    }
    // this.tagService.currentTags.subscribe(tag => this.selectedTagWithId = tag)
    this.mailSubject.valueChanges.subscribe(val => {
      if (val !== '' && this.messageType.includes('new')) {
        this.maxLengthExceeded = (val.length > this.allowedCharacters) ? true : false;
      } else {
        this.maxLengthExceeded = false;
      }
    });
  }

  ngOnInit() {
    this.action$.pipe(
      ofType(MessagesActionTypes.SEND_NEW_MESSAGE),
      switchMap((action: SendNewMessage) => {
        return this.api.sendNewMail(action.payload).pipe(
          takeUntil(this.stopper$),
          map((response: any) => {
            /* mail sent successfully */
            this.store.dispatch(new LoaderHide());
            this.notificationService.success('Message sent successfully');
            this.dialogRef.close(true);
            return this.store.dispatch(new GetInbox({ page: 1, 'limit': 10 }));
          }),
          catchError(err => {
            this.notificationService.error(err.error.errors[0].error);
            return of({ type: '' });
          })
        );
      })
    ).pipe(takeUntil(this.stopper$)).subscribe();
    this.store.select(state => state.messages.viewAccessForDoc).pipe(takeUntil(this.stopper$)).subscribe((resp: any) => {
      if (resp.length && this.sendButtonClicked) {
        this.sendButtonClicked = false;
        // const { documents, noAccessDocuments, ...others } = resp;
        // let arrayOfDocumentExists = Object.keys(others).some(key => others[key].length);
        // let NoAccessDocumentExists  =resp.documents.filter((obj) => noAccessDocuments.includes(obj._id) )
        if (resp.length) {
          const documentPopupRef = this.dialog.open(DocAccessPermissionComponent, {
            width: '50%',
            maxHeight: '80vh',
            panelClass: 'cmp-modal',
            data: {
              detail: resp,
              type: 'documentViewAccess',
              panelClass: 'cmp-modal',
              yesButtonText: 'Give access & send mail',
              noButtonText: 'Send email without access'

            }
          });
          documentPopupRef.afterClosed().subscribe((response) => {
            this.ViewAccessClicked = (response && response !== '') ? true : false
            // do nothing
            if ((response)) {
              if (this.inReplyTo) {
                this.payload.inReplyTo = this.inReplyTo;
              }
              this.store.dispatch(new SendNewMessage(this.payload));
            }
            // if (response) {
            //   this.permissionsGiven = true;
            // }
          })
        } else {
          // this case is for no documents and no access documents
          this.store.dispatch(new SendNewMessage(this.payload));
        }
      }
    })

    this.store.select(state => state.messages.addViewAccessForDoc).pipe(takeUntil(this.stopper$)).subscribe((response: any) => {
      if (this.ViewAccessClicked) {
        if (response && response.message) {
          this.notificationService.success('Recipients can view all the documents');
        }
      }
    })
    // this.store.select(state => state.auth.user).subscribe(({ details: { _id: user } }) => {
    //   if (this.messageType === 'reply-all') {
    //     this.loggedInUserId = user;
    //     this.defaultSelection = this.defaultSelection.filter((_id) => (_id !== user))
    //   }
    // })

    this.store.select(state => state.tasks.tagsList).pipe(takeUntil(this.stopper$)).subscribe((taglist) => {
      this.tagsList = taglist.filter((tag) => !this.selectedTagIds.includes(tag._id));
      if (taglist.length) {
        this.addTag = false;
      } else {
        this.addTag = true;
      }
      // console.log(state.tasks.tasksList, "list")
    })
  }

  sendEmail() {
    if (this.permissionsGiven) {
      this.store.dispatch(new SendNewMessage(this.payload));
    }
    else {
      if (this.selectedTagWithId) {
        this.newSelectedTagIds = this.selectedTagWithId.map(tag => tag._id)
      }

      if (this.maxLengthExceeded) {
        return false;
      }

      this.sendButtonClicked = true;
      let docIds = this.docsList.map((doc) => (doc._id || doc.id));
      if (this.toRecipient.length == 0) {
        this.noRecipient = true;
        return false;
      }
      this.payload = {
        ...this.mail,
        to: this.toRecipient.map(recipient => recipient._id),
        cc: [],
        bcc: [],
        references: this.references,
        attachments: docIds,
        type: (this.messageType === 'reply-all') ? 'replyAll' : this.messageType,
        tags: this.newSelectedTagIds ? this.newSelectedTagIds : []
      }

      if (docIds.length) {
        let obj = {
          docIds: this.docsList.filter((doc) => doc.status != 2).map((doc) => doc._id || doc.id),
          userIds: this.toRecipient.map(recipient => recipient._id).filter(recipient => recipient !== this.currentUser.details._id)
        }
        // this.dialogRef.close()
        // if(obj.docIds.length) {
        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new ClearViewAccess());
        if (obj.docIds.length && obj.userIds.length) {
          this.store.dispatch(new CheckViewAccessGorDocStart(obj));
        }
        else {
          this.store.dispatch(new SendNewMessage(this.payload));
          this.ViewAccessClicked = false;
        }
      }

      else {
        if (this.inReplyTo) this.payload.inReplyTo = this.inReplyTo;
        this.store.dispatch(new SendNewMessage(this.payload));
        this.ViewAccessClicked = false;
      }
    }

  }

  setRecipient(recipients: any, type: string) {
    switch (type) {
      case 'to':
        this.toRecipient = recipients.selectedItems;
        this.noRecipient = false
        break;
      case 'cc':
        this.ccRecipient = recipients.selectedItems;
        break;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  attachDocument() {
    const dialogRef = this.dialog.open(AllDocumentsDialogComponent, {
      hasBackdrop: true,
      width: '90%',
      height: '80%',
      panelClass: 'compose-mailbox',
    })
    dialogRef.afterClosed().subscribe((document) => {
      if (document != undefined) {
        let index = this.docsList.map((docObj) => (docObj._id || docObj.id)).findIndex((ind) => ind === (document._id || document.id));
        console.log(this.docsList, index);
        if (index === -1) {
          this.docsList.push(document);
        } else {
          console.log('duplicate case');
        }
      }
    })
  }
  remove(doc) {
    let index = this.docsList.map((doc) => doc._id).findIndex((id) => id === doc._id);
    if (index !== -1) {
      this.docsList.splice(index, 1);
      // this.docsList.splice(index, 1);
    }
  }

  uploadNewDocument() {
    const dialogRef = this.dialog.open(UploadDocumentDialog, {
      hasBackdrop: true,
      width: '70%',
      height: '80%',
      panelClass: 'compose-mailbox',
    })
    dialogRef.afterClosed().subscribe((document) => {
      if (document !== undefined && Object.keys(document).length) {
        let index = this.docsList.map((docObj) => docObj._id).findIndex((ind) => ind === document._id);
        if (index === -1) {
          this.docsList.push(document);
        } else {
          console.log('duplicate key');
        }
      }
    })
  }

  // add tags
  addMessageTags(tags: any = []) {
    // this.tagService.newTagsList(tags)
    const dialogRef = this.dialog.open(TagMessagesDialogComponent, {
      width: "40%",
      hasBackdrop: true,
      panelClass: "task-detail-modal",
      data: {
        allDetails: tags,
        type: "messageTags",
        new: true,
        alertTitle: "Add tag to message",
        placeHolder: "Add Tag (search with key words)"
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      // if(res !== undefined && Object.keys(res).length) {
      //   // this.store.dispatch(new AddMessageTag(this.taskDetails.parentId, dataObj, this.taskDetails.threadId))
      //   this.selectedTagWithId = [ ...res];
      // }
      if (res) {
        this.selectedTagWithId = [...res];
      }
    });
  }

  selected(event) {
    let index = this.selectedTags.findIndex(tag => tag === event.option.value.tag);
    if (index === -1) {
      this.selectedTags.push(event.option.value.tag);
      this.selectedTagIds.push(event.option.value._id)
    }
    this.tag = ''
  }

  ngOnDestroy() {
    this.stopper$.next();
    this.stopper$.complete();
  }
}
